import React, { Fragment, useContext } from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Skeleton } from '@mui/material';

import { UserContext } from "../Contexts/UserContext/UserContext.js";
import { FormattedNumber } from "../components/FormattedNumber.js";
import { Slide } from "../display_wallet.js"
import { ButtonPrimary, ButtonPrimaryOutlined } from "../components/Buttons.js";
import SoldeBSV from '../components/SoldeBSV.js';
import SoldeToken from '../components/SoldeToken.js';
import useLog from '../hooks/useLog.js';
import Bold from '../components/Bold.js';
import CoinHeader from '../components/CoinHeader.js';
import Constants, { appConfig } from '../config.js';


// TODO: add a parameter to show the right token we load dynamically
export default function Slide_Balance(props) {
	const function_id = "Slide_Balance: "
	const classname = function_id
	const log = useLog(function_id)

	const userContext = useContext(UserContext)

	const coinProps = userContext.get_selected_coin_props()
	const tokenID = coinProps.tokenid
	const tokenName = coinProps.name
	const tokenName_plural = tokenName + 's'

	// examples: coinProps.tokenid ticker .name .logo .color
	log("coinProps.tokenid=", coinProps.tokenid)

	const isloading = userContext.isloading
	const reloadButton = (isBSV) => (
		<center style={{ marginTop: "10px" }}>
			<ButtonPrimary
				onClick={() => {
					if (isloading) return
					if (isBSV) userContext.reload_bsv()
					else userContext.reload_token()
				}}
				disabled={isloading}
				style={{
					borderRadius: "100px",
					padding: "8px 20px",
				}}
			>
				Refresh Balance &nbsp;
				<i className={"fas fa-sync " + (isloading ? "fa-spin" : "")} />
			</ButtonPrimary>
		</center>
	)

	const tokenAddress = userContext.address_owner
	const bsvAddress = userContext.address_purse

	log(function_id,
		"\n nbjigs = ", userContext.nbjigs, // for debug
		"\n tokenAddress = ", tokenAddress,
		"\n bsvAddress = ", bsvAddress,
	)

	const tokensupply = userContext.tokensupply
	const has_supply = tokensupply != null && !isNaN(tokensupply)
	var supplyTokens_jsx = (
		<Skeleton variant="text" width="8em"
			sx={{ display: "inline-block", bgcolor: "rgba(255,255,255,0.12)" }} />
	)
	if (has_supply) {
		supplyTokens_jsx = <Bold>
			<FormattedNumber value={tokensupply} decimals="0" separator=" " />
			&nbsp; {tokenName_plural}
		</Bold>
	}

	var contentToken_jsx = <Fragment>
		<center>
			<CoinHeader />
			<br />

			<SoldeToken address={tokenAddress ? "tokkenr:" + tokenAddress : null} />
			<br />

			{reloadButton(false)}
			<br />

			<div style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				gap: "0.2em",
				marginBottom: "1em",
			}}>
				<span style={{
					color: appConfig.theme.textColor2,
					fontSize: "0.85em",
					letterSpacing: "0.5px",
					textTransform: "uppercase",
				}}>
					Circulating Supply
				</span>
				{supplyTokens_jsx}
			</div>

			{/* TODO load these infos from token metadata */}
			<div style={{ maxWidth: "24em", margin: "0 auto" }}>
				<ButtonPrimaryOutlined
					href="https://delphe.org/"
					target="_blank"
					rel="noopener noreferrer"
					fullWidth
					style={{ marginBottom: "0.8em" }}
				>
					delphe.org <OpenInNewIcon sx={{ fontSize: "small", marginLeft: "0.4em" }} />
				</ButtonPrimaryOutlined>
				<ButtonPrimaryOutlined
					href="https://t.me/+Iwnd3N20kdU0YzJk"
					target="_blank"
					rel="noopener noreferrer"
					fullWidth
				>
					Telegram <OpenInNewIcon sx={{ fontSize: "small", marginLeft: "0.4em" }} />
				</ButtonPrimaryOutlined>
			</div>
		</center>
		<br /><br /><br />
	</Fragment>


	var contentbsv = <Fragment>
		<center>
			<CoinHeader /><br />

			<SoldeBSV address={bsvAddress ? "bsv:" + bsvAddress : null} />
			<br />

			{reloadButton(true)}
			<br />

			<div style={{ maxWidth: "24em", margin: "0 auto" }}>
				<ButtonPrimaryOutlined
					href="https://academiebitcoin.fr/comment-acheter-du-bitcoinsv-bsv-en-ligne-en-europe/"
					target="_blank"
					rel="noopener noreferrer"
					fullWidth
				>
					Buy or Sell BSV <OpenInNewIcon sx={{ fontSize: "small", marginLeft: "0.4em" }} />
				</ButtonPrimaryOutlined>
			</div>
		</center>
		<br /><br /><br />
	</Fragment>

	return (
		<Slide num={props.num} >
			{coinProps.tokenid === "bsv" ?
			contentbsv
			: (contentToken_jsx? contentToken_jsx: null)}
		</Slide>
	)
}
